import { CommonState, ListParams, Pagination } from './common';

export enum UserValues {
  ADMIN = 'admin',
  MODERATOR = 'moderator',
  SUPPORT = 'support',
  GUEST = 'guest',
  PROMOTER = 'promoter',
}

export const USER_ROLES = [
  { value: 1, title: UserValues.ADMIN },
  { value: 2, title: UserValues.MODERATOR },
  { value: 3, title: UserValues.SUPPORT },
  { value: 4, title: UserValues.GUEST },
  { value: 5, title: UserValues.PROMOTER },
];

export interface UserRoles {
  id: number;
  name: UserValues;
  title: string;
}

export enum UserExtValues {
  API_ACCESS = 'api_access',
  USER_MODIFY = 'user_modify',
  DOWNLOAD_FILE = 'download_file',
}

export type User = {
  id: number;
  name: string;
  email: string;
  avatar: null;
  active: boolean;
  roles: UserRoles[];
  ext: UserExtValues[];
};

export type UserList = {
  data?: User[];
  meta?: Pagination;
};

export type UserListParams = ListParams & {
  name?: string;
  role?: number;
};

export type UserState = CommonState & {
  user?: User;
  userList: UserList;
  userListParams: UserListParams;
  filtersListParams: UserListParams;
};
